import React from "react";
import { CircleCheckBig, Copy, X } from "lucide-react";
import Spacing from "../Spacing";
import { handelCopyLink } from "../../helpers";

export default function GenerateBillViewModal({
  billLink={},
  generateBillOpen=false,
  setGenerateBillOpen=()=>{},
}) {

  return (
    <>
      {generateBillOpen && (
        <div className="docpro_modal_wrap docpro_style_2">
          <div className="docpro_modal_overlay" ></div>
          <div className="docpro_modal" style={{ maxWidth: '500px', background: '#f2f2f5' }}>
            <button
              className="docpro_close_btn"
              onClick={() => setGenerateBillOpen(!generateBillOpen)}
            >
              <X />
            </button>
            <div className="docpro_deleteboxbox">
              <Spacing lg="12" sm="12" />
              <div className="docpro_iconbox_icon docpro_green_color">
                <CircleCheckBig width={75} height={75} />
              </div>
              <Spacing lg="20" sm="20" />
              <div className="docpro_iconbox_right">
                <h3 className="docpro_fs_28 docpro_mb_0">Success</h3>
                <Spacing lg="7" sm="7" />
                <p className="docpro_fs_16">Payment link generated successfully</p>
                <textarea
                  style={{
                    border: "1px solid var(--border)",
                    padding: "8px 10px",
                    fontSize: "16px",
                    borderRadius: "12px",
                    backgroundColor: "#fff",
                    resize: "none",
                    textAlign: 'center',
                    color: 'var(--accent)',
                  }}
                  className="docpro_form_field size_lg"
                  cols="30"
                  rows="1"
                  defaultValue={billLink?.docpro_shortener_link}
                  readOnly
                ></textarea>
                <Spacing lg="35" sm="35" />
                {/* <div className="docpro_data_table_btns" style={{ padding: 0, flexWrap: 'nowrap' }}> */}
                  {/* <button
                    className="docpro_bordered_btn docpro_fw_600 w-full size_lg"
                    onClick={() => setGenerateBillOpen(!generateBillOpen)}
                  >
                    Close
                  </button> */}
                  <button 
                    onClick={() => handelCopyLink(billLink?.docpro_shortener_link)}
                    className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn size_lg"
                    style={{ padding: '16px 28px' }}
                  >
                    <Copy width="15" height="15" />
                    Copy
                  </button>
                {/* </div> */}
              </div>
              <Spacing lg="12" sm="12" />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
